
<template>
  <div class="promotion-modal">
    <h1>Dodaj promocję</h1>
    <ul class="button-row">
      <li
        @click="activeForm = 0"
        class="option-btn"
        :class="{active: activeForm === 0}"
      >Hashtag</li>
      <li
        @click="activeForm = 1"
        class="option-btn"
        :class="{active: activeForm === 1}"
      >Obserwujący</li>
      <li
        @click="activeForm = 2"
        class="option-btn"
        :class="{active: activeForm === 2}"
      >Lokalizacja</li>
    </ul>
    <transition name="fade-slide" mode="out-in">
      <div v-if="activeForm === 0" class="form" :key="3">
        <p>Wpisz popularne hasztagi Instagramowe. Należy wybrać takie hasztagi, żeby użytkownicy,
          którzy wykonują polubienia oraz komentują zdjęcia z takimi hasztagami byli potencjalnie
          zainteresowani tematyką Twojego promowanego profilu.</p>
        <form>
          <label for="promotion-name">Hashtag</label>
          <br>
          <input
            placeholder="Nazwa hashtagu..."
            required
            v-model="label"
            type="text"
            id="promotion-name"
          >
          <br>
        </form>
        <button @click.prevent="createPromotion">Dodaj</button>
      </div>
      <div v-else-if="activeForm == 1" class="form" :key="1">
        <p>Wpisz nazwę instagramowego profilu. Promocja będzie kierowana do jego obserwatorów,
          najlepsze efekty przyniesie więc wybranie profilu, którego obserwatorzy byliby
          zainteresowani treściami publikowanymi przez Ciebie.</p>
        <form>
          <label for="promotion-name">Profil</label>
          <br>
          <input
            placeholder="Nazwa profilu na Instagramie..."
            required
            v-model="label"
            type="text"
            name
            id="promotion-name"
          >
          <br>
        </form>
        <button @click.prevent="createPromotion">Dodaj</button>
      </div>
      <div v-else-if="activeForm === 2" class="form" :key="2">
        <p>Możesz wyszukiwać lokalizacje według nazwy, adresu, miasta lub kraju, otrzymując
          listę najbardziej popularnych miejsc w pobliżu.</p>
        <form>
          <label for="promotion-name">Lokalizacja</label>
          <br>
          <input
            placeholder="Nazwa lokalizacji..."
            required
            v-model="label"
            type="text"
            name
            id="promotion-name"
          >
          <br>
        </form>
        <button @click.prevent="createPromotion">Dodaj</button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AddPromotionModal',
  data() {
    return {
      activeForm: 0,
      label: ""
    };
  },
  methods: {
    createPromotion() {
      const payload = {
        promotionType: this.activeForm,
        label: this.label
      };

      this.$store.dispatch('createPromotion', payload);
      this.$store.dispatch('showLoadingModal', true);
    }
  }
};
</script>

<style lang="scss">
.promotion-modal {
  width: 60vw;
  height: 480px;
  position: relative;
  overflow: hidden auto;
  padding: 15px;
  @media (max-width: 768px) {
    width: 95vw;
  }
}

.form {
  position: relative;
  top: -2px;
  border: 1px solid #444;
  border-radius: 5px;
  padding: 20px;
  background: rgb(29, 29, 29);
  margin: 0 auto;
  overflow: auto;
  & p {
    text-align: left;
    margin-bottom: 35px;
  }
}

.button-row {
  display: flex;
  flex-direction: row;
  list-style: none;
  margin: 0;
  margin-top: 10px;
  position: relative;
  font-size: 16px;
  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
    margin: 10px 0;
  }
}

.option-btn {
  height: 33px;
  border-radius: 10px 10px 0 0;
  line-height: 2;
  padding: 0 10px;
  margin: 0 3px;
  border: 1px solid #444;
  cursor: pointer;

  &.active {
    border: 1px solid #3670ce;
    background: #3670ce;
    cursor: default;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 25px;
    margin: 3px 2px;
  }
}
</style>
